export default class FindDistributor {
    constructor() {
        this.section = document.querySelector('.component-find-distributor');
        this.select = this.section.querySelector('#estadoSelect');
        this.citySelect = this.section.querySelector('#cidade');
        this.svgMap = this.section.querySelectorAll('a.state');

        this.containerList = this.section.querySelector('#containerList');
        this.distributorList = this.section.querySelector('#distribuidorList');

        this.getDistributors();
    }

    getDistributors() {
        const business = this.section.dataset.local;

        fetch(`/getDistributor?business=${encodeURIComponent(business)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                window.addEventListener('beforeunload', () => {
                    sessionStorage.removeItem('distributors');
                });

                sessionStorage.setItem('distributors', JSON.stringify(data.distributor));
            })
            .catch((error) => {
                console.error('There was a problem with the fetch operation:', error);
            });

        this.stateChange();
        this.mapClick();
    }

    updateDistributorList(distributors, uf) {
        this.containerList.classList.remove('active');
        this.distributorList.innerHTML = '';

        if (uf != 'SP') {
            distributors.forEach((distributor) => {
                const template = this.templateShowDistribuitors(
                    distributor.title,
                    distributor.email,
                    distributor.phone,
                    distributor.address,
                    distributor.city,
                    distributor.site,
                    distributor.state,
                    distributor.states_list
                );
                this.distributorList.insertAdjacentHTML('beforeend', template);
            });

            this.containerList.classList.add('active');
        } else {
            this.citySelect.addEventListener('click', (e) => {
                const cidade = e.target.value;

                this.containerList.classList.remove('active');
                this.distributorList.innerHTML = '';

                const filteredDistributors = distributors.filter((distributor) =>
                    distributor.cities_list
                        .split(',')
                        .map((city) => city.trim())
                        .includes(cidade)
                );

                filteredDistributors.forEach((distributor) => {
                    const template = this.templateShowDistribuitors(
                        distributor.title,
                        distributor.email,
                        distributor.phone,
                        distributor.address,
                        distributor.city,
                        distributor.site,
                        distributor.state,
                        distributor.states_list
                    );
                    this.distributorList.insertAdjacentHTML('beforeend', template);
                });

                this.containerList.classList.add('active');
            });
        }
    }

    mapClick() {
        this.svgMap.forEach((estado) => {
            estado.addEventListener('click', (e) => {
                const uf = estado.getAttribute('id');
                this.eventDataMapSelect(uf);
            });
        });
    }

    stateChange() {
        this.select.addEventListener('change', (e) => {
            const uf = e.target.value;
            this.eventDataMapSelect(uf);
        });
    }

    eventDataMapSelect(uf) {
        const storedDistributors = JSON.parse(sessionStorage.getItem('distributors')) || [];
        const distributors = storedDistributors.filter((distributor) => distributor.states_list.includes(uf));

        if (uf == 'SP') {
            const citiesList = [
                ...new Set(
                    storedDistributors
                        .filter((distributor) => distributor.state === 'SP')
                        .flatMap((distributor) => distributor.cities_list.split(',').map((city) => city.trim()))
                ),
            ];

            this.citySelect.innerHTML = '';

            const defaultOption = document.createElement('option');
            defaultOption.value = '0';
            defaultOption.textContent = 'Selecione a cidade';
            this.citySelect.appendChild(defaultOption);

            citiesList
                .sort((a, b) => a.localeCompare(b))
                .forEach((city) => {
                    const option = document.createElement('option');
                    option.value = city;
                    option.textContent = city;
                    this.citySelect.appendChild(option);
                });
            this.section.querySelector('#cidadesSP').classList.remove('hidden');
        } else {
            this.section.querySelector('#cidadesSP').classList.add('hidden');
        }

        if (distributors.length > 0) {
            this.select.value = uf;

            this.svgMap.forEach((element) => element.classList.remove('active'));
            const matchingElements = Array.from(this.svgMap).filter((element) =>
                distributors.some((distributor) => distributor.states_list.includes(element.getAttribute('id')))
            );
            matchingElements.forEach((element) => element.classList.add('active'));

            this.updateDistributorList(distributors, uf);
        } else {
            this.templateNoDistribuitor();
            this.select.value = uf;
            this.svgMap.forEach((element) => element.classList.remove('active'));
            const selectedState = Array.from(this.svgMap).find((element) => element.getAttribute('id') === uf);
            if (selectedState) {
                selectedState.classList.add('active');
            }
            this.templateNoDistribuitor();
        }
    }

    templateShowDistribuitors(name, email, phone, address, city, site, state, states) {
        let template = `
            <div class="flex flex-row gap-3">
                <div class="block w-full max-w-[30px] text-white dark:text-shellcinza">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="30" fill="none"><path fill="#FBC600" d="M13 17.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"/><path fill="#FBC600" d="m21.485 21.485-6.364 6.364a3 3 0 0 1-4.24 0l-6.367-6.364a12 12 0 1 1 16.971 0Z"/><path stroke="#FBC600" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 17.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"/><path stroke="#FBC600" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m21.485 21.485-6.364 6.364a3 3 0 0 1-4.24 0l-6.367-6.364a12 12 0 1 1 16.971 0Z"/><circle cx="13" cy="13" r="4.5" fill="currentColor"/></svg>
                </div>
                <div class="flex w-full max-w-[305px] gap-4">
                    <div class="flex flex-col gap-1">`;
        if (name) {
            template += `<p class="text-sm/extra font-medium text-shellcinza dark:text-white">${name}</p>`;
        }
        if (address) {
            template += `<p class="text-sm/extra text-shellcinza dark:text-white">${address}</p>`;
        }
        // if(city && state) {
        //     template += `<p class="text-sm/extra text-shellcinza dark:text-white">${city}, ${state}</p>`;
        // }
        if (email) {
            template += `<p class="text-sm/extra text-shellcinza dark:text-white">${email}</p>`;
        }
        if (phone) {
            template += `<p class="text-sm/extra text-shellcinza dark:text-white">${phone}</p>`;
        }
        if (site) {
            template += `<a href="${site}" target="_black" class="text-sm/extra text-shellcinza dark:text-white hover:underline underline-offset-4">${site}</a>`;
        }
        if (states) {
            template += `<p class="text-sm/extra text-shellcinza dark:text-white">Estados atendidos: ${states}</p>`;
        }
        if (email) {
            template += `<p class="text-sm/extra text-shellcinza dark:text-white">
                                <a href="mailto:${email}" target="_blank" class="text-sm/extra font-medium text-shellcinza dark:text-white flex flex-row gap-2 items-center hover:text-shellred">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.5 3.333c0-.92-.746-1.667-1.667-1.667H3.167c-.92 0-1.667.746-1.667 1.667m15 0v8.333c0 .92-.746 1.667-1.667 1.667H3.167c-.92 0-1.667-.747-1.667-1.667V3.333m15 0-7.5 5-7.5-5"/></svg> <span>Entre em contato</span>
                                </a>
                            </p>
                            `;
        }
        template += `</div>
                </div>
            </div>
        `;
        return template;
    }

    templateNoDistribuitor() {
        const template = `
            <p><strong>Nenhum distribuidor encontrado para o estado selecionado.</strong></p>
        `;
        this.containerList.classList.remove('active');
        this.distributorList.innerHTML = template;
        this.containerList.classList.add('active');
    }
}

if (document.querySelector('.component-find-distributor')) {
    new FindDistributor();
}
